import { render, staticRenderFns } from "./ServiceHallLayout.vue?vue&type=template&id=9e29f924&scoped=true"
import script from "./ServiceHallLayout.vue?vue&type=script&lang=js"
export * from "./ServiceHallLayout.vue?vue&type=script&lang=js"
import style0 from "./ServiceHallLayout.vue?vue&type=style&index=0&id=9e29f924&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e29f924",
  null
  
)

export default component.exports